import { LOGIN, LOGOUT } from './userConstant'

const initialState = {
  userOpenid:undefined,
  user:{
    userInfo:{}
  }
}

export default function userReducer (state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return ({
        userOpenid:action.payload.user.openid,
        user:action.payload.user,
      })
    case 'UPLOAD_VOICE_SUCCESS':
      return ({
        userOpenid:state.userOpenid,
        user:Object.assign({} ,state.user, { 
          isRecorded:true
        })
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/userReducer.js